import { Controller } from '@hotwired/stimulus'

/* global FileReader, Image, DataTransfer */

const MAX_WIDTH = 800

export default class extends Controller {
  static targets = ['input']

  selectFile (event) {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const img = new Image()
      img.onload = () => {
        if (img.width <= MAX_WIDTH) return

        const scale = MAX_WIDTH / img.width
        const canvas = document.createElement('canvas')
        canvas.width = MAX_WIDTH
        canvas.height = Math.round(img.height * scale)

        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

        canvas.toBlob((blob) => {
          const resizedFile = new File([blob], file.name, { type: file.type })
          const dt = new DataTransfer()
          dt.items.add(resizedFile)
          this.inputTarget.files = dt.files
        }, file.type)
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }
}
